import * as React from "react";
import {IOrderDetail} from "../models/IOrderDetail";
import {DefaultHeader} from "./headers/DefaultHeader";
import {HealthHeader} from "./headers/HealthHeader";

export function DetailsHeader(props: { order: IOrderDetail | null }) {
	if (!props.order || !props.order.policyId)
		return (<div></div>);
	
	if (props.order.comparatorId === "healthcare")
		return <HealthHeader order={props.order}/>;
	
	return <DefaultHeader order={props.order}/>;
}
